let domain = '.saas.quanmai.cloud';
export default domain;